module.exports = "/assets/2AbvxlrH2X.png";